import React from 'react'
import { classes, HeroStyle } from './style'
import Typography from '@mui/material/Typography'
import SearchLocationInput from '../../../components/SearchLocationInput'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'

const Hero = () => {
  const containerRef = React.useRef(null)

  return (
        <HeroStyle className={classes.root} ref={containerRef}>
            <div className={classes.heroContent}>
             <div>
               <Typography className={classes.title} color="primary">To Each Their Home</Typography>
               <br/>
                <Typography className={classes.subtitle}>Let’s find a home that’s perfect for you</Typography>
                <br/>
                <SearchLocationInput/>
                <Link to={'/search'} style={{ textDecoration: 'none' }}>
                    <Button variant="contained" color="primary" className={classes.separator}>View More</Button>
                </Link>
             </div>
            </div>
        </HeroStyle>
  )
}

export default Hero
